import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { config } from '@app/app.config';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form: any = new FormGroup({
    password: new FormControl('')
  });
  passwordReset: boolean;

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit(): void {}

  submitResetPassword() {
    const token = this.route.snapshot.queryParams.token;
    const password = this.form.value.password;

    this.http
      .post(config.httpURL + '/api/reset-password', null, { params: { token, password } })
      .subscribe(arg => (this.passwordReset = true));
  }
}
